import {ApplicationRef, ComponentFactoryResolver, Injectable, ViewContainerRef} from '@angular/core';
import {ToastOptions, ToastsManager} from 'ng2-toastr';

@Injectable()
export class ToasterService {
  constructor(
    private _toastr: ToastsManager,
  ) { }

  setViewContainer(vcr: ViewContainerRef) {
    this._toastr.setRootViewContainerRef(vcr);
  }

  showError(msg = 'Something went wrong. Please try again later.') {
    this._toastr.error(msg, 'Oops!');
  }

  showWarning(msg: string) {
    this._toastr.warning(msg, 'Alert!');
  }

  showInfo(msg: string) {
    this._toastr.info(msg);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/global/toaster.service.ts